<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" (click)="open(back)"><img src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-4">
    <h2>Create Course</h2>
    <p>Please add the following information to create a new course</p>
</div>
    </div>
</div>
<div class="sttperWrap">
    <div class="sttperHead">
        <ul>
            <li>
                <!-- <a href="javascript:void(0);" class="active" [routerLink]="['/courses_create']"><b>01</b>Course Details</a> -->
                <a href="javascript:void(0);" class="active"><b>01</b>Course Details</a>
            </li>
            <li>
                <!-- <a href="javascript:void(0);" class="active" [routerLink]="['/courses_add_modules']"><b>02</b>Add Modules</a> -->
                <a href="javascript:void(0);" class="active"><b>02</b>Add Modules</a>
            </li>
            <li>
                <!-- <a href="javascript:void(0);" class="active" [routerLink]="['/courses_add_review']"><b>03</b>Review</a> -->
                <a href="javascript:void(0);" class="active"><b>03</b>Review</a>
            </li>
            <li *ngIf="!type">
                <!-- <a href="javascript:void(0);" class="events-none" [routerLink]="['/courses_add_assign_user']"><b>04</b>Assign Users</a> -->
                <a href="javascript:void(0);" class="events-none"><b>04</b>Assign Users</a>
            </li>
        </ul>
    </div>
    <div class="sttperBody mt-4 w-100">
        <div class="centerWrap">
        <div class="adminInnerHead pt-2">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="userCouresLatest ">
                        <div class="imgUploadWrap">
                            <span class="userCouresImage" style="background: url(assets/images/demo.png);"></span>
                        </div>
                        <div class="userCouresContent">
                            <h3>{{courseData.course_name}}</h3>
                            <p>
                                <span>{{courseData.module_count}} Modules</span>
                                <span>{{courseData.submodule_count}} Sub Modules</span>
                                <span>{{courseData.assessment_count}} Assessment</span>
                            </p>
                            <p>
                                <span>End Date: {{courseData.end_date}}</span>
                                <!-- <a href="javascript:void(0);" class="btn-link" >EXTEND</a> -->
                            </p>
                    </div>
                </div>
                </div>
                <div class="col-12 col-md-5">
                    <div class="courseTabs pb-1">
                        <p>{{courseData.course_desc}}</p>
                    </div>
                </div>
                <div class="col-12 col-md-1 d-inline-flex justify-content-center align-items-center">
                    <a href="javascript:void(0);" class="btn-link d-block text-uppercase" [routerLink]="['/courses_create']" [queryParams]="{Id:courseData.course_id,pro:'review'}">Edit</a>
                </div>
            </div>
        </div>
        </div>
        <div class="tabsWrap">
                  <mat-tab-group animationDuration="0ms" [selectedIndex]="activeTab" >
                    <mat-tab *ngFor="let values of courseData.courseModules; let i = index">
                        <ng-template mat-tab-label>
                            <b>Module {{i+1}}:</b>{{values.module_name}} 
                            <a href="javascript:void(0);" class="btn-link d-block text-uppercase" [routerLink]="['/courses_add_modules']" [queryParams]="{courseId:courseData.course_id,pro:'review',ModId:values.module_id}">Edit</a>
                        </ng-template>
                        <div class="contentBody">
                            <div class="pl-4 mt-4 pr-4">
                                <div class="moduleHead">
                                    <div class="mudleSubHead">
                                        <h3><b>Module {{i+1}}:</b>{{values.module_name}}</h3>
                                    <!-- <ul class="modifyIcons">
                                        <li>
                                            <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                        </li>
                                    </ul> -->
                                </div>
                                </div>
                                <p>{{values.module_desc}}</p>
                            </div>
                            <hr/>
                            <div class="submudleWrap">
                            <mat-accordion>
                                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                                *ngFor="let subValues of values.subModules; let j = index">
                                  <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <div class="moduleHead">
                                            <div class="submudleHead ">
                                                <h3> <b>SUB MODULE {{j+1}}:</b>{{subValues.submodule_name}}</h3>
                                                <div class="viewpass">
                                                    <a href="javascript:void(0);" class="btn-link text-uppercase" [routerLink]="['/courses_add_modules']" [queryParams]="{Id:courseData.course_id,pro:'review',ModId:values.module_id}">Edit</a>
                                                </div>
                                                <ul class="modifyIcons">
                                                    <li *ngIf="subValues.assessment_id"><a href="javascript:void(0);"><img
                                                                src="assets/images/icons/frame.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[0]==1"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[0]==2"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[0]==3"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>

                                                    <li *ngIf="subValues.media_type[1]==1"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[1]==2"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[1]==3"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/video-camera.svg"></a></li>

                                                    <li *ngIf="subValues.media_type[2]==1"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[2]==2"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[2]==3"><a
                                                            href="javascript:void(0);"><img
                                                                src="assets/images/icons/video-camera.svg"></a></li>

                                                </ul>
                                            </div>
                                        </div>
                                    </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p>{{subValues.submodule_desc}}</p>                                    
                                </mat-expansion-panel>
                            </mat-accordion>
                            </div>  
                            </div>
                    </mat-tab>
                  </mat-tab-group>
        </div>
    </div>
    <div class="sttperFooter">
        <div class="row m-0">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)=open(cancel)>Cancel</a>
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)=open(back)>Back</a>
            <div class="ml-auto" *ngIf="!type">
                <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="SaveDraft()"><span>Save as Draft</span></a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="open(publish)">Publish Course</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" [routerLink]="['/courses_add_assign_user']"
                 [queryParams]="{courseId:courseId}">Assign Users & Publish</a>
            </div>
            <div class="ml-auto" *ngIf="type">
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="open(update)">Update & Save</a>
            </div>
        </div>
    </div>
</div>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
            <figure>
                <img src="assets/images/hourglass.png">
            </figure>
            <h6>Hold Tight!</h6>
            <p>Your request to increase the number of attempts available for assessments, has been sent to the administrator for review and approval.</p>
        <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click')">
            <span>Close</span>
        </a>
    </div>
    </div>
  </ng-template>
  <ng-template #publish let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Publish course</h6>
                <p class="size18">Are you sure you want to publish this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="coursePublised(courseId)">Yes, Publish</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #update let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Update course</h6>
                <p class="size18">Are you sure you want to update this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="coursePublised(courseId)">Yes, Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #publish let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Publish course</h6>
                <p class="size18">Are you sure you want to publish this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="coursePublised(courseId)">Yes, Publish</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #back let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Back to course add module</h6>
                <p class="size18">Are you sure you would like to back to course add module?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);"  class="btn btn-primary btn-sm" (click)="cancelbkModule()">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #cancel let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
              <div>
                <h6>Cancel Course</h6>
                <p class="size18">Are you sure you would like to Cancel Course?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="cancelCourse()">Confirm</a>
            </div>
        </div>
    </div>
</ng-template> 
